<div class="my-2">
  <om-label *ngIf="this.props?.label" [text]="this.props?.label" [isRequired]="this.props?.required"></om-label>
  <nz-card class="px-2 py-2">

    <!-- upload area -->
    <nz-upload nzType="drag" [nzMultiple]="false" [nzShowUploadList]="false" [nzOpenFileDialogOnClick]="true"
      [nzShowButton]="true" [nzCustomRequest]="handleUpload" class="mx-1" [nzDisabled]="this.formControl.disabled">
      <button nz-button>
        <i nz-icon nzType="paper-clip"></i>
        {{ 'ATTACHMENTS.UPLOAD_FILE' | translate }}
      </button>
    </nz-upload>

    <!-- files table -->
    <div style="max-height: 12rem" class="w-full overflow-y-scroll">
      <div *ngFor="let vm of vm$ | async" nz-row
        class="pt-3 px-2 w-full flex flex-row flex-nowrap justify-between hover:bg-gray-100">
    
      <!-- file row -->
      <ng-container *ngIf="!vm.isPicture; else pictureRow">
        <div nz-col>
          <div class="flex items-start overflow-hidden mb-2 h-7 cursor-pointer">
            <ng-template [ngTemplateOutlet]="icon"></ng-template>
            <div class="py-1 mx-1" (click)="this._showAttachments(vm)">{{vm.attachment.fileName}}</div>
          </div>
        </div>
        
        <div nz-col>
          <div class="flex flex-row flex-nowrap justify-start">
            <i class="cursor-pointer block py-1 mx-1" nz-icon nzType="download" nzTheme="outline"
              (click)="this._showAttachments(vm)"></i>
            <i class="cursor-pointer block py-1 mx-1" nz-icon nzType="delete" nzTheme="twotone" nzTwotoneColor="#d81111"
              (click)="this._deleteAttachment(vm.attachment.id)"></i>
          </div>
        </div>
        
        <ng-template #icon>
          <div style="width: 32px; min-width: 32px; display: flex; justify-content: center;" class="mx-1">
            <i nz-icon [nzType]="vm.iconNzType" class="mr-1 text-base" nzTheme="twotone" [nzTwotoneColor]="vm.iconColor"></i>
          </div>
        </ng-template>
      </ng-container>

    <ng-template #pictureRow>
      <div nz-col>
        <div class="flex items-start overflow-hidden mb-2 h-7 cursor-pointer" (click)="this._showAttachments(vm)">
          <ng-template [ngTemplateOutlet]="icon"></ng-template>
          <div class="py-1 mx-1">{{vm.attachment.fileName}}</div>
        </div>
      </div>
    
      <div nz-col>
        <i class="cursor-pointer block py-1 mx-1" nz-icon nzType="delete" nzTheme="twotone" nzTwotoneColor="#d81111"
          (click)="this._deleteAttachment(vm.attachment.id)"></i>
      </div>
    
      <ng-template #icon>
        <div style="width: 32px; min-width: 32px; display: flex; justify-content: center;" class="mx-1">
          <img nz-image nzDisablePreview class="mr-2 object-cover" style="width: 26px; height: 26px"
            [nzSrc]="vm.base64Thumbnail" [alt]="vm.attachment.fileName" />
        </div>
      </ng-template>
    </ng-template>
    
      </div>
    </div>
  </nz-card>
</div>
